/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated.js';
import { UnitDependencies } from './dependenciesUnitClass.generated.js';
import { createRydberg } from '../../factoriesAny.js';
export var rydbergDependencies = {
  BigNumberDependencies,
  UnitDependencies,
  createRydberg
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesRydberg.generated.js
// module id = hGwK
// module chunks = 3